import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const EcoFriendlyPeriodCare = () => {
  useMetaTags({
    title: "Eco-Friendly Period Care: The Environmental Impact of Sanitary Pads",
    description: "Discover the hidden environmental cost of traditional sanitary pads and explore biodegradable and reusable alternatives for a sustainable future.",
    keywords: "eco-friendly sanitary pads, sustainable period care, biodegradable pads, reusable menstrual products, plastic-free period solutions",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/eco-friendly-period-care",
    ogTitle: "Eco-Friendly Period Care: The Environmental Impact of Sanitary Pads",
    ogDescription: "Traditional sanitary pads contribute to massive plastic pollution. Learn how to switch to sustainable, biodegradable, and reusable period products.",
    ogImage: "https://img.freepik.com/premium-photo/covid19-plastic-waste-garbage-disposable-masks-alcohol-gel-bottle-needle-trash-bin_53476-6132.jpg",
    ogUrl: "https://organicpads.shop/eco-friendly-period-care",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Eco-Friendly Period Care: Reduce Your Menstrual Waste",
    twitterDescription: "Make the switch to sustainable period products and reduce plastic waste from traditional sanitary pads.",
    twitterImage: "https://img.freepik.com/premium-photo/covid19-plastic-waste-garbage-disposable-masks-alcohol-gel-bottle-needle-trash-bin_53476-6132.jpg",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });
  
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/eco-friendly-period-care"
    },
    "headline": "Eco-Friendly Period Care: The Environmental Impact of Sanitary Pads",
    "description": "Discover the hidden environmental cost of traditional sanitary pads and explore biodegradable and reusable alternatives for a sustainable future.",
    "image": "https://img.freepik.com/premium-photo/covid19-plastic-waste-garbage-disposable-masks-alcohol-gel-bottle-needle-trash-bin_53476-6132.jpg",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "eco-friendly sanitary pads",
      "sustainable period care",
      "biodegradable pads",
      "reusable menstrual products",
      "plastic-free period solutions"
    ]
  }
 

  return (
    <>
    <div className="max-w-3xl mx-auto px-4 mt-20 py-8">
      <h1 className="text-3xl font-bold mb-6">
        The Environmental Impact of Traditional Sanitary Pads
      </h1>

      <img
        src="https://img.freepik.com/premium-photo/covid19-plastic-waste-garbage-disposable-masks-alcohol-gel-bottle-needle-trash-bin_53476-6132.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid"
        alt="Environmental Impact"
        className="w-full h-auto rounded-lg mb-6"
      />

      <p className="mb-4">
        Traditional sanitary pads have a devastating environmental impact that
        often goes unnoticed. Each conventional pad contains the equivalent of
        four plastic bags and takes over 500 years to decompose. The cumulative
        effect of millions of users worldwide creates an environmental crisis
        that demands immediate attention.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        Environmental Costs of Traditional Pads
      </h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Massive plastic pollution in oceans</li>
        <li>Microplastic contamination in soil</li>
        <li>Chemical leaching into groundwater</li>
        <li>Overwhelming landfill contribution</li>
        <li>Non-renewable resource depletion</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        How to Reduce Your Period Waste?
      </h2>
      <p className="mb-4">
        Choose <strong>biodegradable alternatives</strong> and consider reusable
        options. Every switch to sustainable products prevents hundreds of
        plastic pads from entering landfills annually.
      </p>

      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG9yZ2FuaWMlMjBzYW5pdGFyeSUyMHBhZHN8ZW58MHx8MHx8fDA%3D.jpg"
        alt="Waste reduction"
        className="w-full h-auto rounded-lg mb-6"
      />

      <h2 className="text-2xl font-semibold mt-6 mb-4">Final Thoughts</h2>
      <p className="mb-4">
        Your choice of menstrual products has a lasting impact on the
        environment. <strong>Choose sustainably for a better future!</strong>
      </p>
    </div>
     {/* Schema Markup */}
     <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default EcoFriendlyPeriodCare;
